import React from 'react'
import { Edit, SimpleForm, TextInput, useTranslate } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

export const BillingEdit = (props) => {
  const translate = useTranslate()
  return (
    <Edit {...props} actions={null}>
      <CardCommon title={translate('ra.field.application')} actions={null}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['name']} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput source='name' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.address')}>
              <TextInput source='address' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.region')}>
              <TextInput source='region' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.type_responsible')}>
              <TextInput source='type_responsible' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_type')}>
              <TextInput source='document_type' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.document_number')}>
              <TextInput source='document_number' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.phone_number')}>
              <TextInput source='phone_number' label={false} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}